import { ReactComponent as IPhone } from "./iPhone-1.svg";
import { ReactComponent as IPad } from "./iPad-3.svg";
import { ReactComponent as Mac } from "./mac-4.svg";
import { ReactComponent as Android } from "./android-5.svg";
import { ReactComponent as AndroidTablet } from "./androidTablet-6.svg";
import { ReactComponent as WebDevice } from "./webDevice-9.svg";
import { ReactComponent as IPhoneNotch } from "./iPhoneNotch-10.svg";

const icons = {
  1: IPhone,
  2: IPad,
  3: IPad,
  4: Mac,
  5: Android,
  6: AndroidTablet,
  9: WebDevice,
  10: IPhoneNotch
};

export default function getDeviceIcon(xmppLogin) {
  const deviceNumber = xmppLogin[xmppLogin.length - 1];
  return icons[deviceNumber] || icons[1];
}
